function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .zt0{fill:none;stroke:#0071BC;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 26.6,
  y: 2.2,
  className: "zt0",
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.6,
  y: 2.2,
  className: "zt0",
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 26.6,
  y: 13.2,
  className: "zt0",
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.6,
  y: 13.2,
  className: "zt0",
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("polyline", {
  className: "zt0",
  points: "2.5,13 6.7,17.3 16.6,7.4     "
}));

var SvgGridViewActive = function SvgGridViewActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "girdenable block",
    id: "Layer_12",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "23.1px",
    viewBox: "0 0 48 23.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridViewActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid_view_active.47e40ca7.svg";
export { ForwardRef as ReactComponent };